import React from "react";
import css from "./Center.module.scss";

export const Center = ({children}) =>
  children ? (
    <div data-testid={"EntityListItem-Center"} className={css.itemContent}>
      {children}
    </div>
  ) : null;
